import { useId } from "react";
import * as RadioGroup from "@radix-ui/react-radio-group";
import type {
  RadioGroupItemProps,
  RadioGroupProps,
} from "@radix-ui/react-radio-group";

import styles from "./styles.module.scss";

type Item = { value?: string; label: string; disabled?: boolean } & Omit<
  RadioGroupItemProps,
  "value"
>;

const getValue = (item: Item) => item.value || item.label;

interface ToggleProps {
  options: Item[];
  label?: string;
}

export function Toggle({
  options,
  label,
  ...rest
}: ToggleProps & Omit<RadioGroupProps, "className">) {
  const id = useId();
  const labelId = `${id}-label`;
  return (
    <div data-component="toggle-group" className={styles.wrap}>
      {label && (
        <label className={styles.label} id={labelId}>
          {label}
        </label>
      )}
      <RadioGroup.Root
        aria-labelledby={label ? labelId : undefined}
        {...rest}
        className={styles.container}
      >
        {options.map((option) => {
          const itemId = `${id}-${getValue(option)}`;
          return (
            <div key={getValue(option)} className={styles["item-container"]}>
              <RadioGroup.Item
                {...option}
                className={styles.item}
                value={getValue(option)}
                id={itemId}
              >
                <RadioGroup.Indicator className={styles.indicator} />
              </RadioGroup.Item>
              <label htmlFor={itemId} className={styles["item-label"]}>
                {option.label}
              </label>
            </div>
          );
        })}
      </RadioGroup.Root>
    </div>
  );
}
